module.exports = __webpack_public_path__ + "img/photo04.b98d8a7a.jpg";